import '../SCSS/App.scss';
import Navigation from '../component/nav-bar';


const Soni = () => {
    return (
       

      <div className="p-5">

{/* <Navigation /> */}
            
            <h1>I am a Support page</h1>

            <h1>This page are not available </h1>

            
  
   </div>
       
   )
 }


export default Soni;